import React from "react";
import {Link} from "react-router-dom";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <div className=" text-white flex flex-col items-center p-6">
      <h1 className="md:text-2xl text-lg mb-4">- HOW WE SUCCESS -</h1>
      <p className="md:text-md text-xs text-center max-w-2xl mb-8 leading-relaxed tracking-wide">
        ELIOVA is a project management Co. that focuses on delivering unique and challenging design projects. We offer independent, professional project management consulting services to Owners across a variety of industries and sectors. Our delivery of project management and management advisory relies on our highly qualified and experienced team of experts at ELIOVA who are invested in ensuring projects are executed with quality and professionalism to the clients’ utmost expectations.
      </p>
      <div className="relative flex flex-col lg:flex-row items-center gap-6 min-w-[100%] bg-white text-gray-500">
        <div className="p-6 w-full lg:w-1/2 text-right md:text-lg text-sm">
          <h2 className="md:text-2xl text-lg font-semibold mb-4">CONTACT US</h2>
          <p className="mb-2 ">Eliova</p>
          <p className="mb-2">3019 Archambault, Longueuil, QC J4M 2W9 CANADA</p>
          <p className="mb-2">T: 514.892.2510 </p>
          <p className="mb-4">
            <a href="mailto:info@smithvigeant.com" className="text-orange hover:underline">
              eliovaconstruction@gmail.com
            </a>
          </p>
          <div className="lg:absolute contact-social flex justify-center space-x-6 mt-4">
            <Link
              class='social-icon-link facebook'
              to='/'
              target='_blank'
              aria-label='Facebook'
            >
              <i class='fab fa-facebook-f' />
            </Link>
            <Link
              class='social-icon-link instagram'
              to='/'
              target='_blank'
              aria-label='Instagram'
            >
              <i class='fab fa-instagram' />
            </Link>
            <Link
              class='social-icon-link youtube'
              to='/'
              target='_blank'
              aria-label='Youtube'
            >
              <i class='fab fa-youtube' />
            </Link>
            <Link
              class='social-icon-link twitter'
              to='https://ca.linkedin.com/company/concepteliova'
              target='_blank'
              aria-label='LinkedIn'
            >
              <i class='fab fa-linkedin' />
            </Link>
          </div>
        </div>
        <div className="p-6 w-full lg:w-1/2 text-right text-lg">
          <div className="max-h-[50vh] min-w-[100%]">
            <img className="max-h-[50vh] min-w-[100%]" src="/images/monotoni/4.jpg" alt={"contact image"}/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
